import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    width: 100%;
    flex: 1;
    padding: 2rem;
    padding-bottom: 0;
    gap: .75rem;
    flex-direction: column;
    background: #f3f4f6;
    .disabled{
      pointer-events: none;
      opacity: 0.7;
      cursor: not-allowed;
    }
    .column{
      display: flex;
      width: 100%;
      align-items: center;
      gap: 1rem;
      font-weight: 400;
    }
`;
export const BoxSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  .box--{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    .line-{
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      justify-content: space-between;
      .date{
        width: 10rem;
        border: 1px solid #1D86FF;
        background-color: transparent;
      }
    }
  }
  .list-{
    width: 20rem;
  }
`;
export const BtnSearch = styled.button`
    outline: none;
    border: none;
    display: flex;
    width: 3rem;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    color: #ffffff;
    background-color: #1D86FF;
    font-size: 1.5rem;

    .loader{
      display: flex;
      border: 2px solid #1d83e2 ;
      border-radius: 50%;
      border-top: 2px solid #ffffff;
      width: 2rem;
      height: 2rem;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
`;
export const Title = styled.div`
  position: relative;
  max-width: 700px;
  text-align: center;
  padding: 1rem;
  border-radius: 4px;
  font-size: 1.3rem;
  font-weight: bolder;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  margin-top: 1.75rem;
  > span {
    position: absolute;
    display: flex;
    width: 5rem;
    height: 5rem;
    top: -35px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffff;
    background-color: #1D86FF;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px
  }
  > div {
    margin-left: 5rem;
  }
`;
export const FilterWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 400px;
  .input-filter { 
    border-radius: 4px;
    max-width: 450px;
    background: #ffffff;
    border:solid 1px #e8e8e8;
  }
`
export const Content = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
  >.chart{
   min-height: auto;
  }
`;